import * as React from 'react';
import { FormattedMessage } from 'react-intl';

import { WithStyles } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import FormLabel from '@material-ui/core/FormLabel';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import TextField from '@material-ui/core/TextField';

import { createStyles, withStyles } from '@material-ui/core/styles';

import { GREEN, NoteColor, ORANGE, PINK, YELLOW } from '../constants';


const commonStyle = {
    color: 'black',
    fontFamily: '"Gloria Hallelujah", cursive',
    fontSize: 48,
    lineHeight: 1.5,
    padding: 20,
};

const styles = createStyles({
    dialog: {
        paddingBottom: 10,
    },
    GREEN: {
        ...commonStyle,
        background: GREEN
    },
    ORANGE: {
        ...commonStyle,
        background: ORANGE
    },
    PINK: {
        ...commonStyle,
        background: PINK
    },
    YELLOW: {
        ...commonStyle,
        background: YELLOW
    },
    greenRadio: {
        color: GREEN + ' !important'
    },
    orangeRadio: {
        color: ORANGE + ' !important'
    },
    pinkRadio: {
        color: PINK + ' !important'
    },
    yellowRadio: {
        color: YELLOW + ' !important'
    },
    background: {
        background: '#ffffff',
    }
});

interface Props {
    readonly open: boolean,
    readonly text: string,
    readonly color: NoteColor,
    readonly onDialogCancel: () => void,
    readonly onDialogClosed: () => void,
    readonly onTextareaChanged: (text: string) => void,
    readonly onColorChanged: (color: NoteColor) => void
}


function getNoteColor(color: string) {
    switch (color) {
        default:
            return NoteColor.YELLOW;
        case 'PINK':
            return NoteColor.PINK;
        case 'GREEN':
            return NoteColor.GREEN;
        case 'ORANGE':
            return NoteColor.ORANGE;
    }
}

const NoteDialog = ({ open, text, color, classes, onDialogCancel, onDialogClosed, onTextareaChanged, onColorChanged }: Props & WithStyles) => {

    const textfieldChangedHandler: React.ChangeEventHandler<HTMLInputElement> = event => {
        onTextareaChanged(event.target.value);
    };

    return (
        <Dialog classes={{paper: classes.dialog}} open={open} onClose={onDialogCancel}>
            <DialogContent>
                <TextField
                    InputProps={{
                        classes: {
                            input: classes[color],
                        },
                        disableUnderline: true,
                    }}
                    inputRef={ref => ref && ref.setAttribute('cols', '16')}
                    autoFocus={true}
                    id="text"
                    multiline={true}
                    fullWidth={true}
                    rows={4}
                    value={text}
                    onChange={textfieldChangedHandler}
                />
                <div className={classes.background}>
                    <FormLabel><FormattedMessage id="note_dialog_pick_color"/></FormLabel>
                    <RadioGroup value={color} row={true} onChange={(event, value) => onColorChanged(getNoteColor(value))}>
                        <Radio value={NoteColor.YELLOW} classes={{root: classes.yellowRadio, checked: classes.yellowRadio}}/>
                        <Radio value={NoteColor.PINK} classes={{root: classes.pinkRadio, checked: classes.pinkRadio}}/>
                        <Radio value={NoteColor.GREEN} classes={{root: classes.greenRadio, checked: classes.greenRadio}}/>
                        <Radio value={NoteColor.ORANGE} classes={{root: classes.orangeRadio, checked: classes.orangeRadio}}/>
                    </RadioGroup>
                </div>
            </DialogContent>
            <DialogActions>
                <Button color="default" onClick={onDialogCancel}>
                    <FormattedMessage id="cancel"/>
                </Button>
                <Button color="primary" onClick={onDialogClosed}>
                    <FormattedMessage id="ok"/>
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default withStyles(styles)(NoteDialog);


// WEBPACK FOOTER //
// ./src/components/NoteDialogView.tsx